import { cx } from '@linaria/core';
import { RefObject, SyntheticEvent, memo, useCallback, useRef } from 'react';
import { locales } from '../../../locales/en';
import { SEARCHSTATE } from '../../../state';
import { deleteSearchHistoryItem, resetSearchHistory, updateSearchQuery } from '../../../state/state.search';
import Button from '../../Buttons/Button';
import Chip from '../../common/Chip';
import { useClickAway } from '../../Hooks/useClickAway';
import { useRouteSelector } from '../../Hooks/useRoute';
import { useHistory } from '../../Hooks/useSearch';
import "./InputHistory.linaria.module.css!=!./InputHistory?./InputHistory.linaria.module.css?css=H4sIAAAAAAAAA51XTXOjOBC9z6/IZSuTqiGFbAw2c9m97WV/g0ogAQIhYUl8hZr/voUNRMKewG6qkko/uqV2d7/m+R3pEpYFVJq35/NQCUU1FTxEkRKs1uTnr2/vo4suIBDqKg7NoEUVAtf9Y36UXCHFVZJ6AyOJDt0Z58cZlzTNjAftFYIUCIb94cOhHJMuvNx/Zo+LgkB3LW3YgKmqGOrDhJFuftz0SzItxTqz0jlgCAqKavCxMocIxUUqRc2xEwsmZNgg+d1xPuG3+QzvBBOdUnawrSESEhPpREJrUTq3j+VIhGmtwnO1pOcdrejj8+ixWE+CTwRGBXGPxex+KyqouhclGMUv95yxRC2RDqYNxUQueZ+uq+B75XdGBy5sqrIN+BCJzlEZwqIN3ap7OU6/4/9fnoBKCNo6Vfw0jP0KUa3F/IwcICjagJfekJFbWpRnRFI9O0QdBKItcB6tzCERXDsJKinrw9d/BNeKSIn064/XvwlriKYxev3x+pekiL3+UIgrRxFJk/lgJsx+LNZQIYwpT51xoI0OMGK5k7X7vX9WRAFJF+tzZFtLxL2FvhHArAC2DpjaZkR47qqzUxY7W1sWENDkfOrAJ8WVpnHRGwSf2DqWw+RqEQW8+VioCn7++vZnSTBFL99L1Dl3Br74rlt1b8MtCLhpzXkO6aHVnrcPsrpx++Db1+T8iqvUOnMLWndx502lwP5JQpC0HW/IXmw1AIdddwWIX/OLdewmtB6c6aabZ3y2Aj/NO60U/SBTwOSvIKcBc1Pbunu3d+b67jIgAYOga/JOgMFcqpgqFDGCHU06vYyhvkDE01b5wwg7WiKuEiHLsK4qImOklvdNImGbHfr8MDCiNZGOqlBMeRq67yeDR8Ls9GI9ztLCbNOdfDUTmyNxbXqQ9xCoIkO52IuZRQdGlyICQXp2U99fmbdF6rQSVeH4Z+lSNyefIusz0h7mNBcgGsbEp00LfNeoApiX9MocRENkwkTr9NbmTmII+sjjrFqZQ14rTZPeiQXXhOtwbBJxIqJbQviOGk50Mdm6Bdmc2kffiSzGmRvIik87l0Sael5VQ8ai+oyfQFZHDu6uQ4XvRziDoPc8wZIn0K3/3s592bWtDuzluAG9vMcZrRyGIsL+V1V0ei7rBEYJT0WyB7FuNJfOaVw6m/d1ZefnGpaoyYC/B3m878ZO9/0sSfnJz2ZRL6PPWruMq+f29rQtaxG55hoynMnaeVpDriEvzP5/mjYXPEtfWBHsIeLeQiMkvZpJLdZQIplS/pDTAUMtr4wh2/qdxtYoVc+E9vj2UH4R0cvw4H4D3ozXkjExi/U4IXf3YwKBl6GobCbB9KCU7indnn3q53xWYrN+vutzU4ldcqhZQVw2xLVUQoaVoFwTaercxMsuTM8692BIRdCDIGsLqNooL49PoDAbt/DXdbSTBsD76AtgdXyFTTOOCSOazC1dDw045oczyc0xsKGnp6y+2wF+ihNfz5rADtkWCKCQrO+8eSis8Kkyv5+Tjc0g07j2TxCI2ucAP4GWfu3c97N+Neq1Ba0Xwn6Na5y4BT1ZJPsVLguiI5J7MXsDHf+TwDVO3YRWe+toKKdTDhM/ubIHzhqsazIIMl/k9cfQEDl+X2QOYjTlYUxM7qZH2JyD4NTa1sAoJ8ubO3if1sG/yrU/wjwRAAA="
const rootStyles = "atm_mk_stnw88 atm_tk_1osqo2v atm_fq_idpfg4 atm_n3_idpfg4 atm_wq_1g1old6 atm_9s_1txwivl atm_vy_1osqo2v atm_2d_1kiau1z atm_45_ftgil2 atm_43_ftgil2";
const paperRootStyles = "atm_5e_bke03k atm_5q_bke03k atm_70_vpmw7n atm_am_1wugsn5 atm_e2_1kw7nm4 atm_vy_1osqo2v atm_45_ftgil2 atm_43_ftgil2 atm_bx_1owkdjb";
const headerContainerStyles = "atm_lo_ftgil2 atm_le_ftgil2 atm_lk_exct8b atm_ll_exct8b atm_40_bke03k atm_2d_1kiau1z atm_mk_1if85x1 atm_tk_idpfg4 atm_wq_kb7nvz atm_10gunnj_i2wt44 atm_1jnqdpg_i2wt44 atm_1mod65r_1fwxnve atm_7anqj9_1fwxnve";
const headerTextStyles = "atm_c8_1fwxnve atm_cs_ni7l0g atm_7l_1xvjxo1 atm_bx_1owkdjb atm_t9_angws6 atm_fr_wh2yj2 atm_lo_i2wt44 atm_le_i2wt44 atm_1qvy1jy_1skhajo";
const tagsContainerStyles = "atm_9s_1txwivl atm_be_1g80g66 atm_cx_i2wt44 atm_iy_jijo1b atm_l1_1wugsn5 atm_fc_1yb4nlp atm_lo_ftgil2 atm_le_ftgil2 atm_lk_exct8b atm_ll_exct8b atm_10gunnj_i2wt44 atm_1jnqdpg_i2wt44 atm_1mod65r_i2wt44 atm_7anqj9_i2wt44 atm_1gg44pu_llbu8d atm_o66bdh_1y44olf atm_1jxwwt7_i2wt44 atm_tg8muf_bfngof atm_xmx6jt_mavh16";
const historyChipStyles = "atm_bv_1kw7nm4 atm_lo_idpfg4 atm_le_idpfg4 atm_lk_1y44olf atm_ll_1y44olf atm_gq_idpfg4 atm_2d_trqlla atm_7l_1s6kbi9 atm_cs_bfngof atm_c8_1fwxnve atm_3f_14habmv atm_5j_exct8b atm_9j_tlke0l atm_e2_1f4h9lt atm_1y17hwk_swbjm3 atm_114zyk1_1y44olf atm_13j28ej_idpfg4 atm_1n5cf6t_1xvjxo1 atm_1krlyx4_1s6kbi9 atm_1qvy1jy_1skhajo atm_rgcu65_1ou6n1d atm_10gunnj_idpfg4 atm_1jnqdpg_idpfg4 atm_1mod65r_1l7b3ar atm_7anqj9_1l7b3ar";
const clearAllStyles = "atm_5j_f6fqlb atm_e2_1f4h9lt atm_vh_1h6ojuz atm_g3_v8775w";
interface IInputHistory {
  autoFocus?: boolean;
  historyId?: string;
  inputRef?: RefObject<HTMLInputElement>;
  list?: Array<string>;
  location?: string;
  open?: boolean;
  page?: string;
  onClose?(event: any, reason: any): void;
  onClear?(event: any): void;
  onDeleteHistoryItem?(item: string, history?: Array<any>): void;
  onEmptyHistory?(history?: Array<any>): void;
  onItemClick?(event: any, value: string): void;
  setOpenHistory?(isOpen: boolean): void;
}
const InputHistory = (props: IInputHistory) => {
  const {
    open = false,
    onDeleteHistoryItem = () => {},
    onEmptyHistory = () => {},
    onItemClick = () => {},
    setOpenHistory = () => {},
    onClear = () => {}
  } = props;
  const rootRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const hasHistory = history && history.length !== 0;
  const visiblePage = useRouteSelector('visiblePage');
  const isExploreOrSearch = visiblePage === 'explore' || visiblePage === 'search';
  const handleChipClick = useCallback((value: string) => () => {
    onItemClick(null, value);
    setOpenHistory(false);
  }, [onItemClick, setOpenHistory]);
  const handleChipDelete = useCallback((value: string) => () => {
    const index = history?.findIndex(item => item === value) ?? -1;
    if (index !== -1) {
      if (SEARCHSTATE.query.search === value) {
        updateSearchQuery({
          search: ''
        });
      }
      deleteSearchHistoryItem(index, onDeleteHistoryItem);
    }
  }, [history, onDeleteHistoryItem]);
  const onButtonClearAllClick = useCallback((event: SyntheticEvent) => {
    event.stopPropagation();
    resetSearchHistory(onEmptyHistory);
    updateSearchQuery({});
    onClear(event);
  }, [onEmptyHistory, onClear]);
  const closeHistory = useCallback(() => setOpenHistory(false), [setOpenHistory]);
  useClickAway(rootRef, open, closeHistory);
  return hasHistory && !isExploreOrSearch && open && <div className={rootStyles} ref={rootRef}>
                <div data-testid="Container__InputHistory" className={cx('paper-container', paperRootStyles)}>
                    <div className={headerContainerStyles}>
                        <span className={headerTextStyles}>
                            Recent Searches
                        </span>
                    </div>
                    <div className={tagsContainerStyles}>
                        {history?.map((value: string, index: number) => <Chip data-testid={`HistoryTag__${value}`} key={`${value}-${index}`} label={value} onClick={handleChipClick(value)} onDelete={handleChipDelete(value)} className={historyChipStyles} />)}
                        <Button border clean data-testid="Button__ClearAll" onClick={onButtonClearAllClick} size="small" className={clearAllStyles}>
                            {locales.search.clearAll}
                        </Button>
                    </div>
                </div>
            </div>;
};
export default memo(InputHistory);